const asId = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "object") {
    const id = value._id || value.id || value.locationId;
    return id ? String(id).trim() : "";
  }
  const raw = String(value).trim();
  return raw === "[object Object]" ? "" : raw;
};

/** Resolve the Agent247 organization/agency scope from active location + user. */
export function resolveAgent247OrganizationId(activeLocation, currentUser) {
  const locationId = asId(activeLocation?._id || activeLocation?.id);
  const userLocation =
    asId(currentUser?.locationId) ||
    asId(currentUser?.activeLocationId) ||
    (Array.isArray(currentUser?.locations)
      ? asId(currentUser.locations[0])
      : "");
  const locationCompany = asId(
    activeLocation?.companyId?._id ||
      activeLocation?.companyId?.id ||
      activeLocation?.companyId,
  );
  const userCompany =
    asId(currentUser?.companyId) ||
    asId(currentUser?.company?._id) ||
    asId(currentUser?.company?.id);

  return locationId || userLocation || locationCompany || userCompany || "";
}

export default resolveAgent247OrganizationId;
